module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAxElEQVR4AWOgC/h+Ufz7JdHbe9TvHVH/cUkEyMWFEBpO7RKbEm82pd3s7nHR35eJ0HBmi2hEdlJEfvz5HaL/rooR1vDljMSBuRKH50t/Pi3x4xIhGxiMV0ORwSomkzXyPts6FtwAIgXfbUAuUBCuAFWD0SpO8zUumQf7ltxS9N6q4L0VyABygYJAKRQNcOPTWs+mtpxl0F7BoL8ShLRWALlAQaAUVhtWdy28wWaxFm4ekAHkAgWBUigazotoE4nooGFQAgDzy81vJ9EkswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/VE.png
// module id = 1297
// module chunks = 0